import "./main.css";

import { AppRoutes } from "@/components/AppRoutes";
import { Toaster } from "@Light/components/page/toast";
import { init } from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./app/store";

const environment = import.meta.env.MODE;
const isRelease = ["production", "staging"].includes(environment);
init({
  enabled: isRelease,
  dsn: "https://0460fcf87e8d1c28916d9d8714f4f2a7@o4506870612688896.ingest.us.sentry.io/4510750775836672",
  environment,
});

// TODO: upgrade to react 19
// createRoot(document.getElementById("root")!, {
//   onCaughtError: reactErrorHandler(),
//   onRecoverableError: reactErrorHandler(),
//   onUncaughtError: reactErrorHandler((error, errorInfo) => {
//     console.error(error, errorInfo.componentStack);
//   }),
// }).render(...)

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AppRoutes />
        <Toaster />
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
